import React, { CSSProperties } from 'react';

type IconProps = {
  w?: number;
  h?: number;
  style?: CSSProperties;
  className?: string;
};

const GatePayIcon = ({ w = 34, h = 24, style, className }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 34 24"
      className={className}
      style={style}
      fill="none"
    >
      <path
        d="M17.1174 17.4986C14.0441 17.4986 11.5534 15.0359 11.5534 11.9991C11.5534 8.96146 14.0449 6.49969 17.1174 6.49969V2C11.5295 2 7 6.47697 7 12C7 17.523 11.5295 22 17.1174 22C22.7052 22 27.2348 17.523 27.2348 12H22.6822C22.6814 15.0359 20.1898 17.4986 17.1174 17.4986Z"
        fill="#2354E6"
      />
      <path d="M22.6802 6.49878H17.1162V11.9982H22.6802V6.49878Z" fill="#17E6A1" />
    </svg>
  );
};

export default GatePayIcon;
